export default "__VITE_ASSET__B2B15zmO__"